"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GrowWrapperStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _constants = require("../constants");
var _TextAreaStyled = require("./TextAreaStyled");
const GrowWrapperStyled = (0, _styled.default)("div")`
    display: grid;
    position: relative;
    width: 100%;
    height: 100%;
    div.${_constants.GROW_WRAPPER_CLASS} {
        /* Hidden from view, clicks, and screen readers */
        visibility: hidden;
        padding: ${_TextAreaStyled.getPadding};
    }
`;
exports.GrowWrapperStyled = GrowWrapperStyled;
//# sourceMappingURL=GrowWrapperStyled.js.map